export const NEW_SUBMIT_EMAIL_FORM = 'new_submit_email_form';

export const EMAIL = 'email';

export const SMALL_SCREEN = '840px';
